import { useState } from 'react'

import { spacings } from '~/assets/styles'

import { Button, Flex, Icon, Typography } from '~/ds-components'

import { Services } from '~/services'

import { useDialog } from '~/utils'

import { MultipleChoicePrize } from '../MultipleChoicePrize'

type MultipleChoiceDrawProps = {
  value: string
  contractNumber: string
  slug: string
}

export const MultipleChoiceDraw = (props: MultipleChoiceDrawProps) => {
  const { value, contractNumber, slug } = props

  const { show } = useDialog()

  const [isRevealed, setIsRevealed] = useState(false)

  const handleClick = () => {
    if (isRevealed) return

    setIsRevealed(true)

    const dialogId = 'premio-revelado'

    setTimeout(
      () =>
        show({
          closableOverlay: false,
          dialogId,
          header: {
            title: '',
            sx: { marginBottom: 0, border: 'none', padding: `${spacings[8]} ${spacings[8]} 0` },
          },
          content: (
            <Flex gap={16} alignItems="center" flexDirection="column">
              <Icon name="Celebration" size={48} color="green" />

              <Typography color="gray.700" variant="xLarge" sx={{ fontWeight: 600 }}>
                {`Parabéns, você ganhou ${value}!`}
              </Typography>

              <Typography color="gray.600" textAlign="center">
                O valor do Prêmio será enviado para a sua loja, que ficará responsável por
                repassá-lo a você.
              </Typography>

              <Typography color="gray.600" textAlign="center">
                Para mais detalhes sobre seu Prêmio, acesse o Sistema Acerta!
              </Typography>

              <Button
                size="medium"
                as="a"
                href={`${process.env.REACT_APP_SISTEMA_ACERTA_URL}/meus-premios`}
                target="_blank"
              >
                Ir para “Meus Prêmios”
              </Button>
            </Flex>
          ),
          slotProps: { body: { sx: { paddingTop: 0 } } },
          size: 'sm',
        }),
      1_000,
    )

    Services.setViewed(contractNumber, slug)
  }

  return (
    <Flex
      as="main"
      display="grid"
      gap={20}
      gridTemplateColumns={'1fr 1fr'}
      maxWidth="580px"
      width="100%"
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <MultipleChoicePrize
          disabled={isRevealed}
          key={`prize-${index}`}
          onClick={() => handleClick()}
          value={value}
        />
      ))}
    </Flex>
  )
}
